var _toConsumableArray = require("/Users/owise1/Dropbox/Os/computers/freelance/Clients/MWright/ambient/fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var visit = require('unist-util-visit');

module.exports = rehypeFilter;
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Element} Element
 *
 * @callback AllowElement
 * @param {Element} element
 * @param {number} index
 * @param {Element|Root} parent
 * @returns {boolean|undefined}
 *
 * @typedef RehypeFilterOptions
 * @property {Array.<string>} [allowedElements]
 * @property {Array.<string>} [disallowedElements=[]]
 * @property {AllowElement} [allowElement]
 * @property {boolean} [unwrapDisallowed=false]
 */

/**
 * @type {import('unified').Plugin<[RehypeFilterOptions]>}
 */

function rehypeFilter(options) {
  if (options.allowedElements && options.disallowedElements) {
    throw new TypeError('Only one of `allowedElements` and `disallowedElements` should be defined');
  }

  if (options.allowedElements || options.disallowedElements || options.allowElement) {
    return function (tree) {
      var node = tree;
      visit(node, 'element', onelement);
    };
  }
  /**
   * @param {Node} node_
   * @param {number|null|undefined} index
   * @param {Node|null|undefined} parent_
   * @returns {number|void}
   */


  function onelement(node_, index, parent_) {
    var node = node_;
    var parent = parent_;
    /** @type {boolean|undefined} */

    var remove;

    if (options.allowedElements) {
      remove = !options.allowedElements.includes(node.tagName);
    } else if (options.disallowedElements) {
      remove = options.disallowedElements.includes(node.tagName);
    }

    if (!remove && options.allowElement && typeof index === 'number') {
      remove = !options.allowElement(node, index, parent);
    }

    if (remove && typeof index === 'number') {
      if (options.unwrapDisallowed && node.children) {
        var _parent$children;

        (_parent$children = parent.children).splice.apply(_parent$children, [index, 1].concat(_toConsumableArray(node.children)));
      } else {
        parent.children.splice(index, 1);
      }

      return index;
    }

    return undefined;
  }
}